export default __webpack_public_path__ + "static/media/Online-black.ceeed278.svg";